import { TUserMinimum } from './newIndex'

export enum ACTION_TYPE {
  TYPE_APPROVAL_STARTED = 'approval-started',
  TYPE_EXTERNAL_APPROVAL_STARTED = 'approval-external-started',
  TYPE_REVISION_REQUESTED = 'revision-requested',
  TYPE_QUESTION_PUSHED = 'question-pushed',
  TYPE_ANSWER_PUSHED = 'answer-pushed',
  TYPE_APPROVED_BY_SYSTEM = 'approved-by-system',
  TYPE_APPROVED_BY_ADMIN = 'approved-by-admin',
  TYPE_APPROVED = 'approved',
  TYPE_APPROVAL_SKIPPED= 'approval-skipped',
  TYPE_UNAPPROVED = 'unapproved'
}

export enum APPROVAL_TYPE {
  TYPE_INTERNAL = 'internal',
  TYPE_EXTERNAL = 'external'
}

export enum POST_SOCIAL_ACTION_TYPE {
  TYPE_STATUS_TRANSITION = 'status-transition',
  TYPE_CONTENT_UPDATED = 'content-updated',
  TYPE_MEDIA_ADDED = 'media-added',
  TYPE_MEDIA_DELETED = 'media-deleted'
}

export enum POST_SOCIAL_STATUS {
  STATUS_DRAFT = 'draft',
  STATUS_PENDING_INTERNAL_APPROVAL = 'pending_internal_approval',
  STATUS_PENDING_EXTERNAL_APPROVAL = 'pending_external_approval',
  STATUS_REQUIRES_REVISION = 'requires_revision',
  STATUS_PENDING_PUBLISH = 'pending_publish',
  STATUS_SCHEDULED = 'scheduled',
  STATUS_LIVE = 'live',
  STATUS_DELETED = 'deleted',
  STATUS_ON_PUBLISHING = 'on_publishing',
  STATUS_PUBLISHING_FAILED = 'publishing_failed',
  STATUS_SKIP_APPROVED = 'skip_approved'
}

export enum POST_STATUS {
  STATUS_TEMPORARY_DRAFT = 'temporary_draft',
  STATUS_DRAFT = 'draft',
  STATUS_PENDING_APPROVAL = 'pending_approval',
  STATUS_REQUIRES_REVISION = 'requires_revision',
  STATUS_PENDING_PUBLISH = 'pending_publish',
  STATUS_SCHEDULED = 'scheduled',
  STATUS_LIVE = 'live',
  STATUS_DELETED = 'deleted',
  STATUS_ON_PUBLISHING = 'on_publishing',
  STATUS_PUBLISHING_FAILED = 'publishing_failed'
}

export enum SOCIAL_NETWORK {
  FACEBOOK_SOCIAL = 'facebook',
  INSTAGRAM_SOCIAL = 'instagram',
  LINKEDIN_SOCIAL = 'linkedin',
  TWITTER_SOCIAL = 'twitter'
}

export enum POST_TYPE {
  POST_TYPE_LINK = 'link',
  POST_TYPE_SINGLE_PHOTO = 'single_photo',
  POST_TYPE_MULTI_PHOTO = 'multi_photo',
  POST_TYPE_MEDIA_CAROUSEL = 'media_carousel',
  POST_TYPE_SINGLE_VIDEO = 'single_video',
  POST_TYPE_MULTI_VIDEO = 'multi_video',
  POST_TYPE_MULTI_CONTENT = 'multi_content',
  POST_TYPE_ANIMATED_GIF = 'animated_gif',
  POST_TYPE_TEXT = 'text',
  POST_TYPE_LINK_CAROUSEL = 'link_carousel',
  POST_TYPE_PHOTO_STORY = 'photo_story',
  POST_TYPE_VIDEO_STORY = 'video_story'
}

export enum POST_ACTION_TYPE {
  TYPE_STATUS_TRANSITION = 'status-transition',
  TYPE_CONTENT_UPDATED = 'content-updated'
}

export enum ATTACHMENT_TYPE {
  TYPE_IMAGE = 'image',
  TYPE_VIDEO = 'video',
  TIPE_GIF = 'gif',
  LINK = 'link'
}

export type MEDIA_DATA_OPTIONS_TYPE = {
  height: number
  ratio: string
  type: ATTACHMENT_TYPE
  width: number
}

export type MEDIA_DATA_TYPE = {
  content_type: string
  file_path: string
  file_size: number
  id: number
  options: MEDIA_DATA_OPTIONS_TYPE
  is_temporary: boolean
  media_collection_type: string
  parent_media_id: number
  original_name: string
  public_url: string
  user_id: number
  canva_design_id: string | null
  previews?: {
    original?: string
    medium?: string
    small?: string
  }
}

export enum MEDIA_REPLICATION_STATUS {
  STATUS_MEDIA_REPLICATION_PENDING = 'pending-duplication',
  STATUS_MEDIA_REPLICATION_IN_PROGRESS = 'in-progress',
  STATUS_MEDIA_REPLICATION_DUPLICATED = 'duplicated',
  STATUS_MEDIA_REPLICATION_FAILED = 'failed'
}

export type TPostAttachment = {
  id: number
  post_social_id: number
  object_data: MEDIA_DATA_TYPE | null
  object_id: number
  object_type: ATTACHMENT_TYPE
  description: ATTACHMENT_DESCRIPTION_TYPE
  preview_image_id: number
  created_at: string
  updated_at: string
  thumbnail_object_data: MEDIA_DATA_TYPE | null
  thumbnail_object_id: number | null
  extra_fields?: TAttachmentExtraFields
}

export enum ATTACHMENT_DESCRIPTION_TYPE {
  MEDIA = 'media',
  LINK = 'link',
  CHILD_LINK = 'child-link'
}

export type TAttachmentExtraFields = {
  [ATTACHMENT_EXTRAFIELD.CONTENT_TAGS]?: TAttachmenTAttachmentFacebookVideoTag[]
  [ATTACHMENT_EXTRAFIELD.LINK]?: string
  [ATTACHMENT_EXTRAFIELD.IS_CHILD_LINK]?: boolean
  [ATTACHMENT_EXTRAFIELD.TITLE]?: string
  [ATTACHMENT_EXTRAFIELD.NAME]?: string
  [ATTACHMENT_EXTRAFIELD.DESCRIPTION]?: string
}

export enum ATTACHMENT_EXTRAFIELD {
  CONTENT_TAGS = 'content_tags',
  LINK = 'link',
  IS_CHILD_LINK = 'is_child_link',
  TITLE = 'title',
  NAME = 'name',
  DESCRIPTION = 'description'
}

export type TAttachmentExtraFieldValues = TAttachmenTAttachmentFacebookVideoTag[] | string | boolean

export type TcompletePostDetails= [] | object
// TODO FBTAGS
export type TAttachmenTAttachmentFacebookVideoTag = {
  id: string
  name: string
}

export type TAprovvalActionCheckbox = {
  id: number
  is_checked: boolean
  label: string
}

export type TApprovalAction = {
  id: number
  type: ACTION_TYPE
  approval_id: number
  created_by_user: TUserMinimum
  message: string
  created_at: string
  updated_at: string
  checkboxes?: TAprovvalActionCheckbox[],
  attachments?:Array<any>
}

export type TApproval = {
  id: number
  type: APPROVAL_TYPE
  approval_id: number
  created_by_user: TUserMinimum
  concrete_approver_user_id: number | null
  approved_by_user: TUserMinimum | null
  post_social_id: number
  is_approved: boolean
  is_master_content: boolean
  concrete_approver_id:number
  status:boolean
  created_at: string
  updated_at: string
}

export type TRound = {
  type: APPROVAL_TYPE
  concreteApproverId: number | null
  onApproveIsNextRoundRequired: boolean
  onApproveNextRoundType: APPROVAL_TYPE | null
  onRevisionNextRoundType: APPROVAL_TYPE.TYPE_INTERNAL
}

export type TApprovalPlan = {
  postId: number
  isSingleRoundInternalApprove: boolean
  isMasterContent: boolean
  masterSocialNetwork: SOCIAL_NETWORK | null
  rounds: {
    [APPROVAL_TYPE.TYPE_EXTERNAL]: TRound
    [APPROVAL_TYPE.TYPE_INTERNAL]: TRound
  } | null
}

export type TPostSocialAction = {
  id: number
  post_id: number
  post_social_id: number
  type: POST_SOCIAL_ACTION_TYPE
  post_social_status: POST_SOCIAL_STATUS
  created_by_user: TUserMinimum
  created_at: string
  updated_at: string
}

export type TExtraFieldsPostSocial = {
  link?: string
  title?: string
  content_tags?: TAttachmentFacebookVideoTag[]
  mentions?: TSocialMention | null
}

export type TSocialMention = any

export type TSocialHashtag = any

export type TSocialLocation = any

export type TShortenLink = any

export type TPostSocialNote = {
  id: number
  post_social_id: number
  message: string | null
  created_by_user: TUserMinimum
  last_updated_by_user: TUserMinimum
  created_at: string
  updated_at: string,
  attachments:Array<any>
}

export type TPostSocial = {
  id: number
  post_id: number
  social_network: SOCIAL_NETWORK
  message: string | null
  type: POST_TYPE
  status: POST_SOCIAL_STATUS
  is_skip_approved?:boolean
  attachment_order: number[]
  first_comment: string | null
  extra_fields: TExtraFieldsPostSocial
  has_multi_attachments: boolean
  created_at: string
  updated_at: string
  deleted_at: string
  last_social_api_response: any
  message_editor_state?: string | null
  is_unapproved:boolean
  is_approved?:boolean
  external_approval_id?: number
  internal_approval_id?: number
  location: string
}

export type TPostAction = {
  id: number
  post_id: number
  type: POST_ACTION_TYPE
  post_status: POST_STATUS
  created_by_user: TUserMinimum
  created_at: string
  updated_at: string
}

export type TPostSchedule = {
  id: number
  post_id: number
  date: string
  time: string
  datetime: string
  scheduled_at: string
  timezone: string
  is_autoposting: boolean
  created_at: string
  updated_at: string
}

export type TPost = {
  id: number
  project_id: number
  type: POST_TYPE
  status: POST_STATUS
  is_skip_approved?:boolean
  message: string | null
  first_comment: string | null
  parent_post_id: number
  created_at: string
  updated_at: string
  deleted_at: string
  master_social_post_id: number
  master_social_network: SOCIAL_NETWORK | null
  concrete_internal_approver: TUserMinimum | null
  concrete_external_approver: TUserMinimum | null
  approval_id:number
  can_approve_post_socials:Array<number>
  can_unapprove_post_socials:Array<number>
}

export type TAttachmentFacebookVideoTag = {
  name: string
  id: string
}
